import { createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { StaffAuthBrandPanel } from '@/components/layouts/components/StaffAuthBrandPanel';
import { MFAVerifyForm } from '@/features/auth/components/MFAVerifyForm';

export const Route = createFileRoute('/login/mfa')({
  component: Page,
  validateSearch: (s: Record<string, unknown>) => ({
    email: typeof s.email === 'string' ? s.email : undefined,
  }),
});

function Page() {
  const { email } = Route.useSearch();
  return (
    <AuthLayout brandPanel={<StaffAuthBrandPanel />} formSide="left">
      <MFAVerifyForm email={email ?? ''} />
    </AuthLayout>
  );
}
